import { atom, selector } from 'recoil';

const SESSION_CONTEXT_KEY = 'opf:sessionContext';

const getStoredContext = () => {
  try {
    const stored = sessionStorage.getItem(SESSION_CONTEXT_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const sessionContextAtom = atom({
  key: 'sessionContextAtom',
  default: getStoredContext()
});

export const routingDecisionSelector = selector({
  key: 'routingDecisionSelector',
  get: ({ get }) => get(sessionContextAtom)?.routingDecision ?? null
});

export const defaultProductKeySelector = selector({
  key: 'defaultProductKeySelector',
  get: ({ get }) => get(sessionContextAtom)?.defaultProductKey ?? null
});

export const defaultBusinessIdSelector = selector({
  key: 'defaultBusinessIdSelector',
  get: ({ get }) => get(sessionContextAtom)?.defaultBusinessId ?? null
});

export const inProgressBusinessIdSelector = selector({
  key: 'inProgressBusinessIdSelector',
  get: ({ get }) => get(sessionContextAtom)?.inProgressBusinessId ?? null
});

export const postLoginBusinessesSelector = selector({
  key: 'postLoginBusinessesSelector',
  get: ({ get }) => get(sessionContextAtom)?.businesses ?? []
});

export const allBusinessLenderStatusesSelector = selector({
  key: 'allBusinessLenderStatusesSelector',
  get: ({ get }) => get(sessionContextAtom)?.allBusinessLenderStatuses ?? {}
});

export const hydrateSessionContext = (set, response) => {
  const context = {
    routingDecision: response.routingDecision || null,
    defaultBusinessId: response.defaultBusinessId || null,
    defaultProductKey: response.defaultProductKey || null,
    inProgressBusinessId: response.inProgressBusinessId || null,
    businesses: response.businesses || [],
    allBusinessLenderStatuses: response.allBusinessLenderStatuses || {}
  };
  sessionStorage.setItem(SESSION_CONTEXT_KEY, JSON.stringify(context));
  set(sessionContextAtom, context);
};

export const resetSessionContext = (reset) => {
  sessionStorage.removeItem(SESSION_CONTEXT_KEY);
  reset(sessionContextAtom);
};
